// extracted by mini-css-extract-plugin
export default {"LogoBox":"Logo_LogoBox__4m9Au","Logo":"Logo_Logo__wpk+s","Logo_name":"Logo_Logo_name__Z3Ivo","Logo_about":"Logo_Logo_about__w-ImH"};